 <template>
    <div>
        <NavigationBar></NavigationBar>
        
        <TrainingMenu></TrainingMenu>

        <CourseBreadcrumb></CourseBreadcrumb>
        
        <router-view class="m-3"></router-view>

        <FooterView></FooterView>
    </div>
</template>
<script>

import NavigationBar from '@/components/shared/Navigation-bar.vue';
import FooterView from '@/components/shared/Footer/Footer-view.vue';
import TrainingMenu from '@/components/Training/Training-menu.vue'
import CourseBreadcrumb from '@/components/Training/Course-breadcrumb.vue'

export default {
    name:'TrainingViews',

    components: {
        NavigationBar,
        FooterView,
        TrainingMenu,
        CourseBreadcrumb
    }
    
}
</script>

